import {
  INavigationProductDescriptor,
  IStoreFrontNavigationContext,
} from '@wix/wixstores-client-core/dist/es/src/types/site-map';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {IProduct} from '@wix/wixstores-graphql-schema/dist/es/src';
import {queryToString} from './urlUtils';
import {ProductPagePaginationItem} from '../types/app-types';
import {CustomUrlApi} from '@wix/wixstores-client-storefront-sdk/dist/es/src/utils/CustomUrl/CustomUrlApi';
import {SectionUrl} from '@wix/wixstores-client-storefront-sdk/dist/src/viewer-script/site-store/SiteStore';

export class NavigationService {
  constructor(
    private readonly siteStore: SiteStore,
    private readonly section: SectionUrl,
    private readonly navigationContext: IStoreFrontNavigationContext,
    private readonly product: IProduct,
    private readonly customUrlApi: CustomUrlApi,
    private readonly isUrlWithOverrides: boolean
  ) {
    //
  }

  private getUrl(slug: string) {
    if (this.isUrlWithOverrides) {
      return this.customUrlApi.buildProductPageUrl({slug});
    } else {
      let prefix: string;
      if (this.section.prefix) {
        prefix = `${this.siteStore.location.baseUrl}/${this.section.prefix}/${slug}`;
      } else {
        prefix = `${this.section.url}/${slug}`;
      }
      return (
        prefix +
        /* istanbul ignore next */ (Object.keys(this.siteStore.location.query).length
          ? /* istanbul ignore next */ `?${queryToString(this.siteStore.location.query)}`
          : '')
      );
    }
  }

  public getPrevNextProducts() {
    const paginationMap = this.navigationContext.paginationMap as (string | INavigationProductDescriptor)[];

    if (this.siteStore.isEditorMode()) {
      return {
        nextProduct: {partialUrl: '#', fullUrl: '#'},
        prevProduct: {partialUrl: '#', fullUrl: '#'},
      };
    }

    let prevProduct = {} as ProductPagePaginationItem;
    let nextProduct = {} as ProductPagePaginationItem;

    const descriptorPaginationMap = paginationMap.map((p) => (typeof p !== 'string' ? p : {slug: p}));
    descriptorPaginationMap.forEach((p, index: number) => {
      if (p?.slug === this.product.urlPart) {
        const prev = descriptorPaginationMap[index - 1];
        const next = descriptorPaginationMap[index + 1];
        if (prev) {
          prevProduct = {
            partialUrl: prev.slug,
            fullUrl: this.getUrl(prev.slug),
          };
        }
        if (next) {
          nextProduct = {
            partialUrl: next.slug,
            fullUrl: this.getUrl(next.slug),
          };
        }
      }
    });

    return {
      nextProduct,
      prevProduct,
    };
  }
}
